import { CSSProperties } from 'react';

export type BarsIconProps = {
  height: number | string;
  width: number | string;
  style?: CSSProperties;
};

const BarsIcon = ({ height, width, ...props }: BarsIconProps) => (
  <svg height={height} width={width} {...props}>
    <rect
      x="0"
      y="106.66666666666667"
      width="15.322866666666664"
      height="53.33333333333333"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="32.25866666666666"
      y="93.33333333333333"
      width="15.322866666666664"
      height="66.66666666666667"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="64.51733333333333"
      y="133.33333333333334"
      width="15.322866666666664"
      height="26.666666666666664"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="96.77599999999998"
      y="120"
      width="15.322866666666664"
      height="40"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="129.03466666666665"
      y="106.66666666666667"
      width="15.322866666666664"
      height="53.33333333333333"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="161.29333333333332"
      y="53.33333333333334"
      width="15.322866666666664"
      height="106.66666666666666"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="193.55199999999996"
      y="120"
      width="15.322866666666664"
      height="40"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="225.8106666666666"
      y="53.33333333333334"
      width="15.322866666666664"
      height="106.66666666666666"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="258.0693333333333"
      y="93.33333333333333"
      width="15.322866666666664"
      height="66.66666666666667"
      transform="matrix(1,0,0,1,0,0)"
      fill="#f25766"
    />
    <rect
      x="15.322866666666664"
      y="133.33333333333334"
      width="15.322866666666664"
      height="26.666666666666664"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="47.581533333333326"
      y="80"
      width="15.322866666666664"
      height="80"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="79.8402"
      y="40"
      width="15.322866666666664"
      height="120"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="112.09886666666665"
      y="80"
      width="15.322866666666664"
      height="80"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="144.35753333333332"
      y="48"
      width="15.322866666666664"
      height="112"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="176.6162"
      y="106.66666666666667"
      width="15.322866666666664"
      height="53.33333333333333"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="208.87486666666663"
      y="80"
      width="15.322866666666664"
      height="80"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="241.13353333333328"
      y="120"
      width="15.322866666666664"
      height="40"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
    <rect
      x="273.39219999999995"
      y="106.66666666666667"
      width="15.322866666666664"
      height="53.33333333333333"
      transform="matrix(1,0,0,1,0,0)"
      fill="#aa2531"
    />
  </svg>
);

export default BarsIcon;
